import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogoTesterComponent } from './logo-tester.component';

/**
 * Módulo dedicado solo para poder reutilizar `app-logo-tester` fuera de
 * ProgramsModule (en flow-tools/components/logo-flow-tester) sin arrastrar
 * ProgramsRoutingModule ni el resto de declarations de Programas.
 */
@NgModule({
  declarations: [LogoTesterComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [LogoTesterComponent],
})
export class LogoTesterModule {}
